import { createAsyncThunk } from "@reduxjs/toolkit";

import { PermissionsService } from "Bands/services";
import { BAND_ACTIONS } from "Bands/types";
import { Dispatch } from "react";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";

export const getPermissionTypes = createAsyncThunk(
  BAND_ACTIONS.getPermissionTypes,
  async (bandId: string, { rejectWithValue }) => {
    try {
      return await PermissionsService.getPermissionTypes({
        band: API_ENDPOINTS.BAND(bandId),
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const dispatchGetBandUsersPermissions = ({
  dispatch,
  page,
  rootGroupId,
  ...props
}: {
  dispatch: Dispatch<any>;
  page?: number;
  bandId: string;
  permissionTypes: string[];
  rootGroupId: string;
}) => {
  dispatch(
    getBandUsersPermissions({
      ...props,
      rootGroupPath: API_ENDPOINTS.PERMISSION_GROUP(rootGroupId),
      page: page || 1,
      paginationKey: API_ENDPOINTS.PERMISSION_GROUP(rootGroupId),
    })
  );
};

const getBandUsersPermissions = createAsyncThunk(
  BAND_ACTIONS.getBandUsersPermissions,
  async (
    {
      bandId,
      page,
      permissionTypes,
      rootGroupPath,
    }: {
      bandId: string;
      permissionTypes: string[];
      rootGroupPath: string;
      page: number;
      paginationKey: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const data = await PermissionsService.getBandUsersPermissions({
        band: API_ENDPOINTS.BAND(bandId),
        type: permissionTypes.map((id) => API_ENDPOINTS.PERMISSION_TYPE(id)),
        page,
      });

      // keep the key even if response is empty
      return {
        [IDataKeys.groupUserPermissions]: {
          [rootGroupPath]: data.bandUser,
        }, // change key
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUserPermissions = createAsyncThunk(
  BAND_ACTIONS.getUserPermissions,
  async (userId: string, { rejectWithValue }) => {
    try {
      const data = await PermissionsService.getUserPermissions(userId);

      // change key
      return {
        [IDataKeys.bandUserWithPermissions]: data.bandUser,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserPermissions = createAsyncThunk(
  BAND_ACTIONS.editUserPermissions,
  async (
    { userId, data }: { userId: string; data: { permissions: string[] } },
    { rejectWithValue }
  ) => {
    try {
      await PermissionsService.editUserPermissions(userId, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
